// Module
var code = "<docker-service-tasks-datatable\n  ng-if=\"tasks.length > 0\"\n  dataset=\"tasks\"\n  is-slot-column-visible=\"service.Mode !== 'global'\"\n  service-name=\"service.Name\"\n></docker-service-tasks-datatable>\n";
// Exports
var _module_exports = code;;
var path = 'app/docker/views/services/edit/includes/tasks.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;